export default "__VITE_ASSET__a5bf2d8d__"